import { Box, Typography, IconButton, Stack } from '@mui/joy';
import { Microphone, MicrophoneSlash, VideoCamera, VideoCameraSlash, CameraRotate, Monitor, PhoneDisconnect } from '@phosphor-icons/react';

export default function ButtonsOutcoming({
    isMuted, toggleMute, endCall, isVideoOff, toggleVideo,
    switchCamera, canSwitchCamera,
    toggleScreenShare, isScreenSharing, canShareScreen,
}) {
    const buttons = [
        {
            icon: isMuted ? <MicrophoneSlash size={24} /> : <Microphone size={24} />,
            onClick: toggleMute,
            active: isMuted,
            label: 'Микрофон',
        },
        {
            icon: isVideoOff ? <VideoCameraSlash size={24} /> : <VideoCamera size={24} />,
            onClick: toggleVideo,
            active: isVideoOff,
            label: 'Камера',
        },
        // Переворот камеры — только если есть что переключать (мобильное / ≥2 камеры).
        ...(canSwitchCamera ? [{
            icon: <CameraRotate size={24} />,
            onClick: switchCamera,
            label: 'Перевернуть',
        }] : []),
        // Трансляция экрана — только где поддерживается getDisplayMedia (десктоп).
        ...(canShareScreen ? [{
            icon: <Monitor size={24} weight={isScreenSharing ? 'fill' : 'regular'} />,
            onClick: toggleScreenShare,
            active: isScreenSharing,
            label: isScreenSharing ? 'Остановить' : 'Экран',
        }] : []),
        {
            icon: <PhoneDisconnect size={26} weight="fill" />,
            onClick: endCall,
            danger: true,
            label: 'Завершить',
        },
    ];

    return (
        <Stack direction="row" spacing={3} alignItems="flex-start">
            {buttons.map((btn, i) => (
                <Box key={i} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.75 }}>
                    <IconButton
                        onClick={btn.onClick}
                        sx={{
                            width: 56,
                            height: 56,
                            borderRadius: '50%',
                            boxShadow: 'none',
                            backdropFilter: 'none',
                            transition: 'background-color 0.15s ease, transform 0.1s ease',
                            bgcolor: btn.danger ? '#FF3B30' : btn.active ? '#FFFFFF' : 'rgba(255,255,255,0.16)',
                            color: btn.danger ? '#FFFFFF' : btn.active ? '#001B3D' : '#FFFFFF',
                            '&:hover': {
                                boxShadow: 'none',
                                bgcolor: btn.danger ? '#FF5247' : btn.active ? '#FFFFFF' : 'rgba(255,255,255,0.28)',
                            },
                            '&:active': { transform: 'scale(0.94)' },
                            '& svg': { color: 'inherit' },
                        }}
                    >
                        {btn.icon}
                    </IconButton>
                    <Typography level="body-xs" sx={{ color: 'rgba(255,255,255,0.6)', fontSize: '10px', letterSpacing: '0.03em' }}>
                        {btn.label}
                    </Typography>
                </Box>
            ))}
        </Stack>
    );
}
